import React from "react";

import { TitleSmall } from "Cobalt/Header";
import { Modal, ModalBody, ModalHeader } from "Cobalt/Modal";

const NeedMedicalModal = ({ show, onHide }) => (
  <Modal show={show}>
    <ModalHeader closeButton onHide={onHide}>
      <TitleSmall mt={0} mb={0}>
        Please Select a Medical Plan
      </TitleSmall>
    </ModalHeader>
    <ModalBody>Please select a medical plan before adding a dental plan. You will be able to select a dental plan once you select a medical plan.</ModalBody>
  </Modal>
);

export default NeedMedicalModal;
